const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

async function req(path, options = {}) {
  const res = await fetch(`${BACKEND_URL}/api${path}`, {
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || data.error || `Request failed (${res.status})`);
  return data;
}

const qs = (params = {}) => {
  const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""));
  const s = new URLSearchParams(clean).toString();
  return s ? `?${s}` : "";
};

export const whatsappApi = {
  integrations: (params) => req(`/whatsapp/integrations${qs(params)}`),
  stats: (params) => req(`/whatsapp/stats${qs(params)}`),
  teamMembers: () => req(`/team/members`),

  conversations: (params) => req(`/whatsapp/conversations${qs(params)}`),
  conversation: (id) => req(`/whatsapp/conversations/${id}`),
  messages: (id, params) => req(`/whatsapp/conversations/${id}/messages${qs(params)}`),
  send: (id, payload) => req(`/whatsapp/conversations/${id}/send`, { method: "POST", body: JSON.stringify(payload) }),
  markRead: (id) => req(`/whatsapp/conversations/${id}/read`, { method: "PUT" }),
  assign: (id, assigned_user_id, assigned_user_name) =>
    req(`/whatsapp/conversations/${id}/assign`, { method: "PUT", body: JSON.stringify({ assigned_user_id, assigned_user_name }) }),
  setTags: (id, tags) => req(`/whatsapp/conversations/${id}/tags`, { method: "PUT", body: JSON.stringify({ tags }) }),
  newConversation: (payload) => req(`/whatsapp/conversations/new`, { method: "POST", body: JSON.stringify(payload) }),

  createLead: (payload) => req(`/leads`, { method: "POST", body: JSON.stringify(payload) }),

  // Inbound Meta media is stored as a media id; this URL streams it through
  // the backend using the business's token (cookie auth rides along on <img>).
  mediaUrl: (mediaId, conversationId) =>
    `${BACKEND_URL}/api/whatsapp/media/${encodeURIComponent(mediaId)}?conversation_id=${encodeURIComponent(conversationId)}`,
};
